import { Box, Typography } from "@mui/material";
import { Dayjs } from "dayjs";
import { colorBorder, colorSurfaceDisabled, colorTextDisabled, radiusInput } from "src/design/tokens";

export const TimeDisplay = ({ value }: { value: Dayjs }) => (
  <Box
    sx={{
      display: "inline-flex",
      alignItems: "center",
      gap: 0.5,
      border: `1px solid ${colorBorder}`,
      borderRadius: radiusInput,
      px: 2,
      py: 0.75,
      backgroundColor: colorSurfaceDisabled,
      color: colorTextDisabled,
      width: "100%"
    }}
  >
    <Typography
      variant="body2"
      sx={{ fontFamily: "monospace", letterSpacing: 1 }}
    >
      {value.format("hh")} : {value.format("mm")}
    </Typography>
    <Typography variant="body2" sx={{ ml: 1 }}>
      {value.format("A")}
    </Typography>
  </Box>
);
